import React from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";
import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_SYSTEM_CODES_QUERY } from "../../../graphql/SystemCodes/SystemCodes.graphql";
import { ourToast as toast } from "../../../utils";

const CalcTypeSelect = ({
  name,
  value,
  label,
  disabled,
  required,
  onChange
}) => {
  const { data, loading, error } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Type: "System",
        Category: "Product",
        CodeName: "CalcType"
      },
      orderByMulti: ["CodeDescription_ASC"]
    }
  });
  if (error) {
    toast.error("Error getting Calc Type.");
  }
  return (
    <Field>
      <Label>{label}</Label>
      <Control iconLeft>
        <Select.Container fullwidth state={loading ? "loading" : ""}>
          <Select
            disabled={disabled}
            name={name}
            required={required}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.SystemCodes.map((sysCode, i) => (
                <Select.Option
                  key={`calc-type-select-${i}`}
                  value={sysCode.RecId}
                >
                  {sysCode.CodeDescription}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        <Icon align="left">
          <FontAwesomeIcon icon="globe" />
        </Icon>
      </Control>
    </Field>
  );
};

CalcTypeSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

export default CalcTypeSelect;
